"use client";

import { EditorDashboardContent } from "@hero-app/components/ui/editor/editor-dashboard-content";

export function IframeDashboard() {
  return <EditorDashboardContent className="min-h-0 min-w-0 flex-1" />;
}
